import { useRecoilValue } from 'recoil';
import { Permission, permissionState } from 'state/permissionState';

export default function useHasAccess(permissions: Permission[]): boolean {
  const usersPermissions = useRecoilValue(permissionState);
  return permissions.some(
    p =>
      usersPermissions.includes(p) ||
      usersPermissions.includes(Permission.SUPERADMIN),
  );
}
